<template>
  <v-data-table
    class="elevation-2 mt-5"
    :headers="[
      { text: 'Left On', value: 'createdAt' },
      { text: 'Product', value: 'product.title' },
      { text: 'Average Score', value: 'scoreAverage' },
      { text: 'Verified', value: 'verified' },
      { text: '', value: 'actions', sortable: false },
    ]"
    :items="reviews"
    sort-by="createdAt" sort-desc must-sort
    show-expand
  >
    <template #top>
      <v-toolbar flat color="white">
        <v-toolbar-title>User Reviews</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
      </v-toolbar>
    </template>

    <template #item.createdAt="{ value }">
      {{ value | date }}
    </template>

    <template #item.verified="{ value }">
      {{ value ? 'Yes' : 'No' }}
    </template>

    <template #item.product.title="{ item }">
      <router-link
        class="default-btn link"
        :to="{
          name: 'OrganizationProductsEdit',
          params: { organizationId: item.organizationId, productId: item.productId }
        }">
        {{ item.product.internalName || item.product.title }}
      </router-link>
    </template>

    <template #item.scoreAverage="{ value }">
      <star-rating
        :rating="value"
        :editable="false"
        justify="flex-start" />
    </template>

    <template #item.actions="{ item }">
      <div class="button-group">
        <button
          class="default-btn red slim small"
          @click="$emit('delete', { id: item.id })"
        ><v-icon color="inherit">mdi-delete</v-icon></button>
      </div>
    </template>

    <template #expanded-item="{ headers, item }">
      <td class="pa-2" :colspan="headers.length">
        <condensed-review-details :review="item" />
      </td>
    </template>

    <template #no-data>
      This user has left no reviews
    </template>
  </v-data-table>
</template>

<script>
import CondensedReviewDetails from './CondensedReviewDetails'

export default {
  name: 'UserReviewsTable',
  components: {
    CondensedReviewDetails,
  },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
